import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

import { PickerOptions } from "@ionic/core";

import { NewPageSelectComponent } from '../../new-page-select/new-page-select.component';
import { LazyLoadingSelectComponent } from '../../lazy-loading-select/lazy-loading-select.component';
import { TranslateService } from '@ngx-translate/core';
import { CorpSelectComponent } from '../../corp-select/corp-select.component';
import { OrgCascaderComponent } from '../../../../shared/components/org-cascader/org-cascader.component';
@Component({
  selector: 'report-filter-modal',
  templateUrl: './report-filter-modal.component.html',
  styleUrls: ['./report-filter-modal.component.scss'],
})
export class ReportFilterModalComponent implements OnInit {
  query;
  // 默认筛选条件
  startTime = null;
  endTime = null;
  currentDateString = new Date().toISOString();

  // isCompany;
  // isEmployee;
  // isProject;
  // isWork;
  // isEval;
  // isSupportDoc;

  defaultOrg;
  currentYear;
  reportName;  //报表名称
  needInputName;  //承包商公司名称是否是输入框
  needLocation;  //是否需要地点下拉
  jobRelated; //工作相关下拉框

  contractorCompanyList = [];
  locationsList = [];
  areaList = [];
  premisesList = [];
  answerTypeList = [];

  startDay = new Date(new Date().getFullYear(), 0, 1)
  endDay = new Date(new Date().getFullYear(), 11, 31)
  isEmployee;
  isGmpScore;
  // isContractor: boolean = this.localStorageService.getStore('partyEmployee') === 'true' ? true : false; // 是否是相关方
  constructor(
    public dataService: DataService,
    public appService: AppService,
    public router: Router,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController: ModalController,
    public localStorageService: LocalStorageService,
    public pickerController: PickerController,
    private translateService: TranslateService,
  ) {

    let params = this.navParams.data;
    this.query = params.query;
    this.reportName = params.reportName;
    this.needInputName = params.needInputName;
    this.needLocation = params.needLocation;
    this.jobRelated = params.jobRelated;

    this.defaultOrg = params.defaultOrg;
    this.currentYear = params.currentYear;
    this.isEmployee = params.isEmployee;
    this.isGmpScore = params.isGmpScore;

  }

  ngOnInit() {
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
    // 获取状态code
    if (this.reportName) {
      // this.getProjectList(); // 获取项目列表
      if (!this.needInputName) {
        this.getContractorCompanyList(); // 承包商公司列表
      }
      if (this.needLocation) {
        this.getLocationsList(); // 获取地点列表
      }
      if (this.jobRelated) {
        this.getAnswerTypeList();
      }

      if (this.reportName == 'accident') {
        this.getPremisesList();
      }
    }

  }


  // 获取承包商公司列表
  async getContractorCompanyList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSupplierList(null, this.query.organization.id).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.contractorCompanyList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取答案下拉
  async getAnswerTypeList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_AM').subscribe(res => {
        if (res && res.STATUS === 0) {
          const mediaData = res.DATA[0].childCodes;
          const filterType = ['_SYS_AM_1', '_SYS_AM_2'];
          this.answerTypeList = mediaData.filter(child => filterType.includes(child.code));
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取范围下拉
  async getPremisesList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_WH_11').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.premisesList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }


  // 获取地点列表
  async getLocationsList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      if (this.reportName == 'gmp') {
        that.dataService.getSpaceOfOrgId(this.query.organization.id).subscribe(res => {
          if (res && res.STATUS === 0) {
            this.locationsList = res.DATA;
            resolve();
          } else {
            this.appService.toastTip(res.MSG, false);
            reject();
          }
        });
        return;
      }
      that.dataService.getSpaceOfOrgId().subscribe(res => {
        if (res && res.STATUS === 0) {
          this.locationsList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }


  // 重置条件
  resetSearchFilters() {
    Object.keys(this.query).forEach((item, index) => {
      this.query[item] = null;

    });

    this.query['organization'] = this.defaultOrg;
    this.query['year'] = this.currentYear;
    this.query['startDtm'] = this.startDay;
    this.query['endDtm'] = this.endDay;
    this.query['identificationCardNumber'] = null;

  }

  cancel() {
    this.modalController.dismiss();
  }

  confirm() {
    this.modalController.dismiss({ query: this.query });
  }

  // ==================================Method===========================================

  // 更新报表年份格式
  changeReportYearFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      this.query.year = new Date(selectedDate).getFullYear()
    }
  }

  // 更新开始时间格式
  changeStartTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.endTime && new Date(selectedDate).getTime() - new Date(this.endTime).getTime() > 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.start_time_not_lg_end_time'), true);
      } else {
        this.startTime = new Date(selectedDate).toISOString();
      }
    }
  }
  // 更新结束时间格式
  changeEndTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.startTime && new Date(selectedDate).getTime() - new Date(this.startTime).getTime() < 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.end_time_not_lg_start_time'), true);
      } else {
        this.endTime = new Date(selectedDate).toISOString();
      }
    }
  }


  // 选择地点范围
  async selectPremises() {
    let i = 0;
    if (this.query.onPremises) {
      this.premisesList.forEach((res, index) => {
        if (res.code === this.query.onPremises) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.onPremises = value.premisesObj.value;
          }
        }
      ],
      columns: [
        {
          name: 'premisesObj',
          options: this.getOptionList(this.premisesList),
          selectedIndex: i
        }
      ]
    };
    let picker = await this.pickerController.create(options);
    return picker.present();
  }



  async selectWorkRelated() {
    let i = 0;
    if (this.query.onWork) {
      this.answerTypeList.forEach((res, index) => {
        if (res.code === this.query.onWork) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.onWork = value.workObj.value;
          }
        }
      ],
      columns: [
        {
          name: 'workObj',
          options: this.getOptionList(this.answerTypeList),

          selectedIndex: i
        }
      ]
    };

    let picker = await this.pickerController.create(options);
    return picker.present();

  }

  // 将查询到的code转化为下拉组件可以识别的形式
  getOptionList(list) {
    let options = [];
		list.forEach(item => {
      let lang = localStorage.getItem("APP_LANG");
      switch (lang) {
        case 'zh_CN':
          options.push({ text: item.code_desc_zh, value: item.code });
          break;
        case 'en_US':
          options.push({ text: item.code_desc_en, value: item.code });
          break;
        case 'zh_TW':
          options.push({ text: item.code_desc_tr, value: item.code });
          break;
        case 'vi':
          options.push({ text: item.code_desc_vi, value: item.code });
          break;
        case 'km':
          options.push({ text: item.code_desc_km, value: item.code });
          break;
        case 'th':
          options.push({ text: item.code_desc_th, value: item.code });
          break;
        case 'lo':
          options.push({ text: item.code_desc_lo, value: item.code });
          break;
        default:
          options.push({ text: item.code_desc_en, value: item.code });
          break;
      }
    });
    return options;
  }

  async selectArea() {
    // if (this.editable) {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: CorpSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.incident_location'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.incident_location'),
        originalOptionList: this.areaList,
        selected: this.query.space,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.filter_modals.incident_reporting');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('shared_components.filter_modals.incident_reporting') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.query.space = res.data;
      }
    });
    return await modal.present();
    // }
  }

  // 选择场内地点
  async getAreaList(id): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSpaceOfOrgId(id).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.areaList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }
  getTranslateCode(str) {
    let trans = '';
    if (str) {
      const codes = str.split(',');
      codes.forEach((code, index) => {
        trans += this.translateService.instant(code);
        if (index !== codes.length - 1) {
          trans += ',';
        }
      });
    }
    return trans;
  }

  // 选择相关方公司
  async selectInterestedParty() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        originalOptionList: this.contractorCompanyList,
        displayField: ['name'],
        valueField: '$self',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.interestedParty
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.interestedParty = res.data;
      }
    });
    return await modal.present();
  }

  // 选择组织架构
  async selectOrg() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: OrgCascaderComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.project_name'),
        placeholderMessage: this.translateService.instant('shared_components.common.project_cost_center_code'),
        selected: this.query.organization,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.organization = res.data;
        this.getContractorCompanyList()
      }
    });
    return await modal.present();
  }

  // 选择地点
  async selectLocations() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: CorpSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.locations'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.locations'),
        originalOptionList: this.locationsList,
        selected: this.query.space,
        showInvalid: true
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.space = res.data;
      }
    });
    return await modal.present();
  }

  // 获取层级的地点名称
  getLocationLevelName(space) {
    let spaceName = '';
    if (space && this.locationsList) {
      const namesPath = this.findNodePathById(this.locationsList, space.id);
      spaceName = (namesPath && namesPath.length) > 0 ? namesPath.join(' / ') : '';
    }
    return spaceName;
  }
  findNodePathById(tree, targetId, names = []) {
    // 遍历当前层级的每个节点
    for (const node of tree) {
      // 将当前节点的名字添加到路径名称数组中
      names.push(node.spaceName);
      // 如果当前节点的ID匹配目标ID，则返回路径名称数组
      if (node.id === targetId) {
        return names;
      }
      // 如果当前节点有子节点，则递归查找子树
      if (node.childSpace && node.childSpace.length > 0) {
        // 递归调用，传递当前节点的子树、目标ID以及当前路径
        const foundNames = this.findNodePathById(node.childSpace, targetId, names.slice());
        // 如果在子树中找到了目标ID，则返回找到的名称路径，否则回溯
        if (foundNames) {
          return foundNames;
        }
      }
      // 当前节点不是目标节点且其子节点也没有找到目标ID，从路径中移除当前节点的名字，进行回溯
      names.pop();
    }
    // 如果遍历完当前层级仍未找到目标ID，则返回null
    return null;
  }
}
